import {UserWHMpActionType} from "../../actions/userWHMp/userWHMpAction";
const DefaultUserWHMpState = {
    userWHMpCfg:{},
    userWHMpCfgList:[],
    total:0
}
export const userWHMpReducer = ( state = DefaultUserWHMpState, action = {}) =>
{
    switch (action.type) {
        case UserWHMpActionType.USER_WHMP_CFG_LIST:
            return { ...state, userWHMpCfgList: action?.payload.rows ? action?.payload.rows: [] , total:action?.payload.total?action?.payload.total:0}

        case UserWHMpActionType.USER_WHMP_CFG_INFO:
            return { ...state, userWHMpCfg: action?.payload}
        case UserWHMpActionType.USER_WHMP_CFG_RESET:
            return { ...state, userWHMpCfg: {}}
        case UserWHMpActionType.USER_WHMP_CFG_LIST_RESET:
            return {...state, userWHMpCfgList: []}
        default:
            return state;
    }
}